import { useMutation, useQueryClient } from 'react-query';
import { bffInstance } from '../api/axiosInstance';

const updateDefaultApplication = async (appId: string, isDefault: boolean) => {
  const res = await bffInstance.patch('/updateDefaultApplication', {
    appId,
    isDefault,
  });
  return res.data;
};

export const useUpdateDefaultApplication = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ id, isDefault }: { id: string; isDefault: boolean }) =>
      updateDefaultApplication(id, isDefault),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['unifyProfile']);
      },
    }
  );
};